import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ProjectGroup from "../../models/ProjectGroup";
import Form from "../../components/form/Form";
import User from "../../models/User";
import {useAuth} from "../../providers/AuthProvider";

const EditProjectGroupModal = ({group, projects, ...props}) => {


    // TODO: TAILWIND = get custom dropdown to work on this page


    const {auth} = useAuth();
    const getFormModel = (model) => {
        let superAdmins = [...(props.users || [])].filter(user => user.isClientSuperAdmin());
        let editingGroup = model?.id ? {...model} : {members: superAdmins};
        if (superAdmins.length) {
            TB.map(superAdmins, admin => {
                let exists = TB.find([...(editingGroup.members || [])], ['id', admin.id]);

                if (!exists) {
                    editingGroup.members.push(User.make({...admin, permissions: ProjectGroup.ADMIN_PERMISSIONS}))
                }
            })
        }
        return editingGroup
    }
    const [formModel, setFormModel] = useState(ProjectGroup.make(getFormModel(group)));

    let options = props.users.sort((a, b) => {
        return b.isClientSuperAdmin() - a.isClientSuperAdmin() || b.isClientAdmin() - a.isClientAdmin() || a.first_name.localeCompare(b.first_name)
    })

    options = TB.map(props.users, user => {
        let option = {...user};
        if (user.isClientSuperAdmin()) {
            option.disabled = true;
            option.groupName = 'Admins';
        } else if (user.isClientAdmin()) {
            if (!auth?.canManageGroups() || auth.id === user.id) {
                option.disabled = true;
            }
            option.groupName = 'Admins';
        } else {
            option.groupName = "Active Users";
        }
        return User.make(option)
    });

    options = TB.groupBy(options, 'groupName');
    options = TB.reduce(options, (result, options, groupName) => {
        result.push({name: groupName, options})
        return result;
    }, []);

    const canManageGroups = auth?.canManageGroups();
    const projectOptions = (projects?.length && canManageGroups) ? TB.map(
        TB.orderBy(projects, 'group.name'),
        project => ({...project, disabled: !project.can_change_group})
    ) : undefined;


    const formFields = () => {
        let fields = {
            name: {
                type: 'text',
                maxLength: 250,
                label: false,
                placeholder: 'Group Name',
                required: true,
                disabled: !canManageGroups
            },
            members: {
                type: 'multiselect',
                options,
                required: false,
                // searchEnabled: true,
                label: 'Group Members',
                onReset: () => {
                    if (getFormModel(group)?.members?.length) {
                        return getFormModel(group).members
                    } else {
                        return []
                    }
                },
                displayValue: item => item instanceof User ? item.fullName() : item.name
            }
        };

        if (projectOptions) {

            fields.projects = {
                type: 'multiselect',
                options: projectOptions,
                style: {marginTop: '1rem'},
                required: false,
                // searchEnabled: true,
                label: 'Projects',
                displayValue: project => {
                    return (
                        <span>
                            {project.name}&nbsp;
                            <small className="text-info">
                                {project.group ? project.group.name : 'Public'}
                            </small>
                        </span>
                    )
                }
            }
        }
        return [{fields}]
    }


    return (
        <div className="flex items-stretch">

            <Form
                className="project-group-from"
                onChange={(model) => {

                    let update = {...formModel};
                    for (let [key, value] of Object.entries(model)) {
                        update[key] = value;
                    }
                    setFormModel(ProjectGroup.make(update));
                }}
                fields={formFields()}
                model={formModel}
                submitButton={false}
                cancelButton={false}
                isDisabled={props.disabled}
                onSubmit={() => props.onSubmit(formModel)}>

                {formModel?.projects?.length > 0 && TB.find(formModel.projects, project => TB.isDefined(project.group?.id) && project.group?.id !== group?.id) && (
                    <p className="text-danger text-italic">
                        <small>
                            Note: Moving projects from an existing group will no longer be viewable by members of the previous group.
                        </small>
                    </p>
                )}

                <button type="submit" disabled={props.disabled}
                        className="self-stretch mt-5 btn btn-primary btn-block">
                    {group?.id ? 'Update' : 'Submit'}
                </button>

            </Form>
        </div>
    );
};

EditProjectGroupModal.propTypes = {
    group: PropTypes.object,
    disabled: PropTypes.any,
    onSubmit: PropTypes.func
};

export default EditProjectGroupModal;